import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/onboarding/slurp-diagram.svg")